import { Injectable } from '@angular/core';
import { Http, Response } from '@angular/http';
import { HeaderFactory } from '../../common/HeaderFactory'
import { Observable } from 'rxjs/Rx';
import { UserModel } from '../models/UserModel';

declare const OUTCOMES_API: string;

@Injectable()
export class UserService {
    constructor(
        private http: Http,
        private headerFactory: HeaderFactory
    ) {
        //
    }

    getAuthenticatedUser(): Observable<UserModel> {
        return this.http.get(OUTCOMES_API + '/users/me', {
            headers: this.headerFactory.make()
        }).map(res => res.json());      
    }

    setPermissions(institutionId: number, userName: string, permission: string): Observable<UserModel> {
        return this.http.patch(OUTCOMES_API + '/' + institutionId + '/users/' + userName + '/set-permission/' + permission, null, {
            headers: this.headerFactory.make()
        }).map(res => res.json());        
    }

    syncUsernames(): Observable<Response> {        
        return this.http.patch(OUTCOMES_API + '/users/update-usernames', null, {
            headers: this.headerFactory.make()
        });
    }
}


/** WEBPACK FOOTER **
 ** ./app/users/services/UserService.ts
 **/